module.exports = __webpack_public_path__ + "static/iframe-inspect-86b078d10768a799ed23048378d7232c.png";